import { cn } from "@/lib/utils";

interface WatercolorBlobProps {
  variant?: "orange" | "green";
  className?: string;
  animate?: boolean;
}

export function WatercolorBlob({
  variant = "orange",
  className,
  animate = true,
}: WatercolorBlobProps) {
  const fill =
    variant === "orange"
      ? "var(--contact-orange)"
      : "var(--contact-green)";

  return (
    <svg
      aria-hidden
      viewBox="0 0 400 400"
      className={cn(animate && "contact-blob-drift", className)}
      fill="none"
    >
      <path
        d="M320 80C360 120 380 180 360 240C340 300 280 340 220 360C160 380 100 360 60 300C20 240 20 160 60 100C100 40 180 20 240 40C280 52 300 56 320 80Z"
        fill={fill}
        opacity="0.14"
      />
      <path
        d="M280 120C300 150 310 190 295 230C280 270 250 300 210 310C170 320 130 300 110 260C90 220 100 170 130 140C160 110 210 100 250 105C265 107 275 112 280 120Z"
        fill={fill}
        opacity="0.1"
      />
    </svg>
  );
}
